// Lightweight PostHog CTA tracking. Safe when PostHog is unavailable.
// We intentionally do NOT capture personal information or message body content —
// only the event name and a small set of non-sensitive properties (source, label).

export const trackCta = (event, properties = {}) => {
    try {
        if (typeof window === "undefined") return;
        if (window.posthog && typeof window.posthog.capture === "function") {
            window.posthog.capture(event, {
                ...properties,
                page: "aurea_landing",
            });
        }
    } catch (_e) {
        // swallow — analytics must never break the UI
    }
};
